import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DrCardComponent, DrButtonComponent } from '@datarailsshared/datarailsshared';
import { VideoPlayerComponent } from '../../shared/components/video-player/video-player.component';
import { CONNECTOR_ROUTES, ConnectorRoute } from '@core/models/routes';
import { PROMOTION_CONFIGS, PromotionPageConfig } from './promotion-page.model';

const DEFAULT_CONFIG: PromotionPageConfig = {
    title: 'Coming Soon',
    subtitle: 'This feature is not yet available.',
};

@Component({
    selector: 'app-promotion-page',
    standalone: true,
    imports: [CommonModule, DrCardComponent, DrButtonComponent, VideoPlayerComponent],
    templateUrl: './promotion-page.component.html',
    styleUrls: ['./promotion-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromotionPageComponent {
    public readonly DEFAULT_VIDEO_TITLE = 'Unlock more features with Datarails';
    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);

    readonly config: PromotionPageConfig;
    readonly isConnectorRoute: boolean;

    constructor() {
        const segment = this.route.snapshot.url[0]?.path ?? '';
        this.config = PROMOTION_CONFIGS[segment] ?? DEFAULT_CONFIG;
        this.isConnectorRoute = Object.values(CONNECTOR_ROUTES).includes(segment as ConnectorRoute);
    }

    handleCtaClick(): void {
        const url = this.config.ctaUrl || 'https://www.datarails.com/request-a-demo/';
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    goToAgentsLite(): void {
        this.router.navigate(['/ai-agents']);
    }
}
